import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import axios from "axios";
import App from "./App";
import "styles/app.scss";
import { AuthProvider } from "components/auth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Multi-tenant friendly: by default, talk to whichever tenant subdomain the
// page is being served from (axios uses relative paths against location.origin).
// REACT_APP_BASE_URL only overrides this for non-standard dev setups (e.g. a CRA
// dev server on :3006 hitting a backend on :8100).
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL || window.location.origin;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
